import firebase from 'firebase/compat/app';

const getPersistedBaseViewsRef = (
  accountRef: firebase.firestore.DocumentReference,
) => accountRef.collection('baseViews').where('version', '==', 1);

export default getPersistedBaseViewsRef;
